import settings from "./settings.json";

export class Header {
    //opened;
    dom;
    /**
     * 
     */
    constructor() {
        this.dom = settings.dom;//console.log("xw")
        const $header = this.getDom("header");
        const $burger = this.getDom("burger");
        const $mobile = this.getDom("mobile");
        if ($header instanceof Element && $burger instanceof Element) {
            // events
            $burger.addEventListener("click", e => {
                e.preventDefault();
                if ($header.classList.contains("opened")){
                    this.close($header);
                }else {
                    this.open($header);
                }
            });
            const $as = [...$mobile.querySelectorAll("a")]; 
            $as.forEach($a => {
                $a.addEventListener("click", e => {
                    //e.preventDefault();
                    this.close($header);
                    //window.location.href = $a.href;
                })
            });
            window.addEventListener("resize", e => {
                const $burger = this.getDom("burger");
                if(window.innerWidth > 1280){/////////////////////////////////////////////////////// rendre dynamique avec breakpointBiggerThan
                    this.close($header);
                }
            })
        }
    }
    open($header){
        const $mobile = this.getDom("mobile");
        const $burgerOpen  = this.getDom("burgerOpen");
        const $burgerClose = this.getDom("burgerClose");console.log({$burgerOpen, $burgerClose});
        if($mobile && $burgerOpen && $burgerClose){
            $burgerOpen.classList.add("hide");
            $burgerClose.classList.remove("hide");
            $mobile.classList.remove("hide");
            $header.classList.add("opened");            
        } else console.warn("Header.prototype.open($header) : impossible d'accéder à certains éléments du dom");        
    }
    close($header){
        const $mobile = this.getDom("mobile");
        const $burgerOpen  = this.getDom("burgerOpen");
        const $burgerClose = this.getDom("burgerClose");
        if($mobile && $burgerOpen && $burgerClose){
            $burgerOpen.classList.remove("hide");
            $burgerClose.classList.add("hide");           
            $header.classList.remove("opened");
            $mobile.classList.add("hide");            
        } else console.warn("Header.prototype.close($header) : impossible d'accéder à certains éléments du dom");      
    }
    /* toScroll(e) {
        if (!this.alwaysOnScroll) {
            const $header = this.getDom("header");
            if($header){
                const $topbar = this.getDom("top");
                const h = $topbar.getBoundingClientRect().height;
                if (window.scrollY > h) {
                    if (!$header.classList.contains("onscroll"))
                        $header.classList.add("onscroll");
                } else $header.classList.remove("onscroll");
            }
        }
    } */
    /**
     * 
     * @param {string} name 
     * @returns 
     */
    getDom(name){
        if(name in this.dom)
            return document.querySelector(this.dom[name]) || false;
        return false;
    }
};
